import apiFetch from "../token-guard/apiFetch";

export async function RetrieveBookingByEmail(
  trip_id: string,
  email:string
) {
  try {
    const response = await apiFetch("/api/trip/reterieveBookings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ trip_id, email }),
    });

    return response;
  } catch (error) {
    console.error("Error confirming trip:", error);    
    return (error as Error).message;
  }
}
